<template>
  <dialog-custom
    :is-dialog-open="isDialogOpen"
    max-width="600"
    :close-dialog="closeDialog"
    dialog-title="Associar Fila e Canal"
  >
    <v-form
      ref="formRef"
      class="multi-col-validation"
      @submit.prevent="handleSubmitBtnClick"
    >
      <v-row>
        <v-col cols="12">
          <v-select
            v-model="tipoDeCanalSelecionadoId"
            dense
            outlined
            clearable
            label="Escolha um tipo de canal"
            hide-details
            validate-on-blur
            item-text="nome"
            item-value="id"
            no-data-text="Nenhum tipo de canal disponível"
            :loading="isGetTiposDeCanaisLoading"
            :items="tiposDeCanaisNaoAssociados"
            :rules="[validators.select]"
            @change="getCanaisNaoAssociados"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-select
            v-model="canalSelecionadoId"
            dense
            outlined
            clearable
            label="Escolha um canal"
            hide-details
            validate-on-blur
            item-text="canalNome"
            item-value="canalId"
            no-data-text="Nenhum canal disponível"
            :loading="isGetCanaisNaoAssociadosLoading"
            :items="canaisNaoAssociados"
            :rules="[validators.select]"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          class="d-flex justify-center"
        >
          <v-btn
            color="primary"
            type="submit"
            class="mr-6"
          >
            <v-progress-circular
              v-if="loading"
              class="mx-6"
              indeterminate
              color="secondary"
            />
            <span v-else>Confirmar</span>
          </v-btn>

          <v-btn
            outlined
            color="secondary"
            @click="resetDataAndCloseDialog"
          >
            Cancelar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </dialog-custom>
</template>

<script>
import Vue from 'vue'
import { ref, watch } from '@vue/composition-api'
import { select } from '@core/utils/validation'
import DialogCustom from '@/components/dialog/Dialog.vue'
import FilaService from '@/services/modules/FilaService'
import useDialog from '@/composables/useDialog'
import router from '@/router'

export default {
  components: {
    DialogCustom,
  },

  props: {
    isDialogOpen: {
      type: Boolean,
      required: true,
    },
  },

  setup(props, { emit }) {
    const filaId = router.currentRoute.params.id

    const tiposDeCanaisNaoAssociados = ref([])
    const tipoDeCanalSelecionadoId = ref(null)
    const isGetTiposDeCanaisLoading = ref(false)

    const canaisNaoAssociados = ref([])
    const isGetCanaisNaoAssociadosLoading = ref(false)
    const canalSelecionadoId = ref(0)

    const { formRef, loading, FORM_ERROR, validateForm, resetForm, closeDialog, emitRefetchData } = useDialog(emit, 'isDialogOpen')

    function resetDataAndCloseDialog() {
      resetForm()
      closeDialog()
    }

    async function getTiposDeCanaisNaoAssociados() {
      try {
        isGetTiposDeCanaisLoading.value = true
        tiposDeCanaisNaoAssociados.value = await FilaService.getTiposDeCanaisNaoAssociados(filaId)
      } finally {
        isGetTiposDeCanaisLoading.value = false
      }
    }

    watch(
      () => props.isDialogOpen,
      v => {
        if (!v) return
        getTiposDeCanaisNaoAssociados()
      },
      { immediate: true },
    )

    async function getCanaisNaoAssociados() {
      if (!tipoDeCanalSelecionadoId.value) {
        canaisNaoAssociados.value = []
        return
      }

      try {
        isGetCanaisNaoAssociadosLoading.value = true
        canaisNaoAssociados.value = await FilaService.getCanaisNaoAssociados(filaId, tipoDeCanalSelecionadoId.value)
      } finally {
        isGetCanaisNaoAssociadosLoading.value = false
      }
    }

    async function handleSubmitBtnClick() {
      if (loading.value) return
      if (!validateForm()) {
        Vue.$toast(FORM_ERROR)
        return
      }

      try {
        loading.value = true
        await FilaService.associarFilaECanal(filaId, { canalId: canalSelecionadoId.value })
        emitRefetchData()
        resetDataAndCloseDialog()
      } finally {
        loading.value = false
      }
    }

    return {
      tiposDeCanaisNaoAssociados,
      tipoDeCanalSelecionadoId,
      isGetTiposDeCanaisLoading,

      canaisNaoAssociados,
      canalSelecionadoId,
      isGetCanaisNaoAssociadosLoading,
      getCanaisNaoAssociados,

      formRef,
      loading,
      closeDialog,
      resetDataAndCloseDialog,

      handleSubmitBtnClick,
      validators: {
        select,
      },
    }
  },
}
</script>
